import React from 'react'
import clsx from 'clsx'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    marginBottom: '10px',
    borderBottom: '2px solid #F1F1F1',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',

    '&:focus-within': {
      borderBottomColor: 'black'
    },

    '& .text': {
      opacity: '0.7'
    },

    '& .adorn': {
      marginRight: '10px'
    }
  }
}))

const TextRow = ({ children, title, className }) => {
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)}>
      <div className='adorn'>{title}</div>

      {children}
    </div>
  )
}

export default TextRow
